import { openAssignUserModal } from "../../../../redux/SettingModule/OrganizationDetailPage/OrganizationDetailAction";
import { useAppDispatch } from "../../../../redux/useAppDispatch";
import IsDataNull from "../../../Template/IsDataNull";
import ActionColumnButtons from "../ActionColumnButtons/ActionColumnButtons";
import Table, { ColumnsType } from "antd/es/table";
import { PackType } from "../../../../utils/type";

const UserTableColumn: ColumnsType<PackType> = [
  {
    title: "User Name ",
    key: "username",
    dataIndex: "username",
    // sorter: true,
    render: (data) => <IsDataNull data={data} />,
    width: 200,
  },
  {
    title: "Email ",
    key: "email",
    dataIndex: "emailAddress",
    // sorter: true,
    render: (data) => <IsDataNull data={data} />,
    width: 200,
  },
  {
    title: "Actions ",
    key: "",
    dataIndex: "templates",
    render: (data, record) => (
      <ActionColumnButtons
        type="user"
        record={record}
      />
    ),
    width: 100,
  },
];

function AssignUserTable(props: any) {
  const dispatch = useAppDispatch();
  //Modal

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-2">
        <button
          className="assign-user button d-flex justify-content-start gap-1"
          onClick={() => dispatch(openAssignUserModal())}>
          <span className="material-symbols-outlined">person</span>
          <span>Assign User</span>
        </button>
      </div>

      <Table
        className="table"
        columns={UserTableColumn}
        dataSource={props.data}
        pagination={{
          pageSize: 15,
        }}
        size="small"
      />
    </div>
  );
}

export default AssignUserTable;
